import { FC, memo } from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';
import { getCalendarItemStyle } from './BookingCalendarItem';
import { useSelector } from 'react-redux';
import { selectGetBookingsStatus } from '../store/selectors';
import { RequestStatusEnum } from '@shared/types';

interface BookingCalendarItemSkeletonProps {
    slotIndex?: number;
}

const BookingCalendarItemFallback: FC<BookingCalendarItemSkeletonProps> = ({ slotIndex }) => {
    const theme = useTheme();
    const getBookingsStatus = useSelector(selectGetBookingsStatus);

    return (
        <Box sx={getCalendarItemStyle(theme)}>
            {getBookingsStatus === RequestStatusEnum.Loading && slotIndex === undefined && (
                <Skeleton animation="pulse" />
            )}
        </Box>
    );
};

export default memo(BookingCalendarItemFallback);
